/**
 * Redux actions for content-policy
 * @module services/content-policy/redux/actions
 */

export const DELETE_CONTENT_POLICY = 'DELETE_CONTENT_POLICY'
export const BULK_DELETE_CONTENT_POLICY = 'BULK_DELETE_CONTENT_POLICY'
export const FETCHING_TRANSLATION = 'FETCHING_TRANSLATION'

export const deleteContentPolicy = ({ storeKey, policyId }) => {
  if (!policyId) {
    throw new Error('The contentId parameter is required')
  }

  return {
    type: DELETE_CONTENT_POLICY,
    payload: { storeKey, policyId },
  }
}

export const deleteContentPolicyBulk = ({ storeKey, policyIds }) => {
  if (!policyIds || !policyIds.length) {
    throw new Error('The contentIds parameter is required')
  }

  return {
    type: BULK_DELETE_CONTENT_POLICY,
    payload: { storeKey, policyIds },
  }
}
